export const SITE_NAME = 'MedicarePRO | CRM';
export const SITE_DESCRIPTION =
  'Industry standard CRM and sales tool. Take your insurance business with you wherever, whenever.';
